export * from './featured-ads-adapter';
